import React from "react";


import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import ProjectsSection from "./components/Projects";
import Contact from "./components/Contact";
import Skills from "./components/Skills";
import AddProject from "./AddProject";
import { useState } from "react";



function App() {
  // Set this to true for yourself, false for public
  const isAdmin = true; // Change to false for public build
  const [showAddProject, setShowAddProject] = useState(false);

  const handleAddProjectClick = () => {
    setShowAddProject(true);
  };
  const handleCloseAddProject = () => {
    setShowAddProject(false);
  };

  return (
    <div className="font-sans">
      <Navbar isAdmin={isAdmin} onAddProjectClick={handleAddProjectClick} />
      <Hero />
      <About />
      <Skills />
      <ProjectsSection />
      {isAdmin && showAddProject && <AddProject onClose={handleCloseAddProject} />}
      <Contact />
    </div>
  );
}

export default App;
